import React from 'react';

export default React.createContext<boolean | undefined | null>(null);
